import { useEffect } from "react";
import { alternatesFor, DEFAULT_LANG, HTML_LANG, OG_LOCALE } from "@/i18n/config";

/** Domaine de production officiel (confirmé par la cliente). */
export const SITE_URL = "https://aurassium-clinic.com";

const setMeta = (selector, attr, value) => {
    const el = document.head.querySelector(selector);
    if (el) el.setAttribute(attr, value);
};

/** Balises <link rel="alternate" hreflang> régénérées à chaque route. */
const setAlternates = (alternates) => {
    document.head
        .querySelectorAll('link[rel="alternate"][data-i18n="1"]')
        .forEach((el) => el.remove());
    const add = (hreflang, path) => {
        const link = document.createElement("link");
        link.setAttribute("rel", "alternate");
        link.setAttribute("hreflang", hreflang);
        link.setAttribute("href", SITE_URL + path);
        link.setAttribute("data-i18n", "1");
        document.head.appendChild(link);
    };
    Object.entries(alternates).forEach(([lang, path]) => add(lang, path));
    add("x-default", alternates[DEFAULT_LANG]);
};

/*
 * Métadonnées par route, sans dépendance externe (React 19).
 * Le <head> statique de public/index.html reste la référence pour les
 * crawlers qui n'exécutent pas JavaScript.
 */
export default function useSeo({
    title,
    description,
    path = "/",
    lang = DEFAULT_LANG,
    pageKey,
    soinKey,
    noindex = false,
}) {
    useEffect(() => {
        const url = SITE_URL + path;
        document.title = title;
        document.documentElement.lang = HTML_LANG[lang];
        setMeta('meta[name="description"]', "content", description);
        setMeta('meta[property="og:title"]', "content", title);
        setMeta('meta[property="og:description"]', "content", description);
        setMeta('meta[property="og:url"]', "content", url);
        setMeta('meta[property="og:locale"]', "content", OG_LOCALE[lang]);
        setMeta('meta[name="twitter:title"]', "content", title);
        setMeta('meta[name="twitter:description"]', "content", description);
        setMeta('link[rel="canonical"]', "href", url);
        setMeta(
            'meta[name="robots"]',
            "content",
            noindex ? "noindex, follow" : "index, follow, max-image-preview:large, max-snippet:-1",
        );
        if (!noindex && (pageKey || soinKey)) {
            setAlternates(alternatesFor({ pageKey, soinKey }));
        }
        // La FAQ de l'accueil ne doit être déclarée que sur l'accueil français.
        const faqAccueil = document.getElementById("ld-faq-accueil");
        if (faqAccueil) {
            faqAccueil.type = path === "/" ? "application/ld+json" : "application/json";
        }
    }, [title, description, path, lang, pageKey, soinKey, noindex]);
}
